import { ComponentProps } from "react";
import { H2, P } from "../../../../Atoms";
import { twMerge } from "tailwind-merge";

interface ICardStoreProps extends ComponentProps<"input"> {
  storeName: string;
  address: string;
  serviceHours: string;
}

export const CardStore = ({
  storeName,
  address,
  serviceHours,
  className,
  ...rest
}: ICardStoreProps) => {
  return (
    <label
      className={twMerge(
        "rounded-[10px] border border-solid border-transparent bg-[#E7EDEC] shadow-[0_8px_24px_0_rgba(0,0,0,0.08)] p-4 flex items-start gap-6 w-full cursor-pointer has-[:checked]:border-[#ADB2B1] has-[:checked]:bg-[#D0D5D4] relative",

        className,
      )}
    >
      <input {...rest} type="radio" className="absolute opacity-0" />
      <div className="flex-shrink-0">
        <img src="/assets/svgs/icon-place.svg" alt="icone localização" />
      </div>
      <div className="flex-1 flex flex-col gap-[10px]">
        <H2 className="font-extrabold">{storeName}</H2>
        <span className="block text-xs text-gray-700">{address}</span>
        <span className="block text-xs text-gray-600">{serviceHours}</span>
      </div>
    </label>
  );
};
